import { render, staticRenderFns } from "./pogs-list__item--patient.vue?vue&type=template&id=ab7ddd7e&"
import script from "./pogs-list__item--patient.vue?vue&type=script&lang=js&"
export * from "./pogs-list__item--patient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports